import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What software is used in car design?",
    category: "Technology",
    description:
      "Car designers commonly use Autodesk Alias, Blender, CATIA, SolidWorks, KeyShot, and Photoshop. These tools help with sketching, 3D modeling, surface refinement, rendering, and creating realistic vehicle design concepts.",
  },
  {
    title: "What skills are important for car designers?",
    category: "Trending",
    description:
      "Car designers need creativity, sketching ability, 3D modeling skills, understanding of aerodynamics, ergonomics knowledge, visualization skills, attention to detail, and familiarity with materials, manufacturing, and automotive trends.",
  },
  {
    title: "What job roles exist in the car design field?",
    category: "Design",
    description:
      "Common roles include Automotive Designer, Exterior Designer, Interior Designer, Clay Modeler, 3D Surface Modeler, CAD Designer, Color and Trim Designer, and Visualization Artist within automotive companies.",
  },
  {
    title: "What industries hire car designers?",
    category: "Design",
    description:
      "Car designers work in automotive companies, electric vehicle startups, motorsport teams, design studios, transportation firms, and mobility innovation labs that create concept cars, futuristic vehicles, and advanced mobility solutions.",
  },
  {
    title: "What is the future of car design?",
    category: "Design",
    description:
      "Car design is evolving with electric vehicles, autonomous driving, smart interiors, sustainable materials, futuristic lighting, and digital dashboards. Designers increasingly focus on technology integration and user-centric design.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
